import { create } from 'zustand';

interface FavoriteAnimation {
  id: string;
  productImage?: string;
  startX: number;
  startY: number;
  timestamp: number;
}

interface FavoriteAnimationState {
  animations: FavoriteAnimation[];
  triggerAnimation: (product: {
    productImage?: string;
    startX: number;
    startY: number;
  }) => void;
  removeAnimation: (id: string) => void;
}

export const useFavoriteAnimation = create<FavoriteAnimationState>((set) => ({
  animations: [],
  
  triggerAnimation: (product) => {
    const id = `${Date.now()}-${Math.random()}`;
    const animation: FavoriteAnimation = {
      id,
      productImage: product.productImage,
      startX: product.startX,
      startY: product.startY,
      timestamp: Date.now(),
    };
    
    set((state) => ({
      animations: [...state.animations, animation],
    }));
    
    // Auto-remove after animation completes
    setTimeout(() => {
      set((state) => ({
        animations: state.animations.filter(a => a.id !== id),
      }));
    }, 800);
  },
  
  removeAnimation: (id) => {
    set((state) => ({
      animations: state.animations.filter(a => a.id !== id),
    }));
  },
}));
